

export const fetchData = async () => {
    const response = await fetch('https://api.github.com/users/eddapeturs');
    const data = await response.json();
    return data;
}

export const postData = async (url = '', data = {}) => {
    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    });
    return await response.json();
}

export const createUser = async (data = {}) => {
    let url = 'https://leynifelagid.askell.is/signup'
    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    });
    return await response.json();
};

export const fetchTokenStatus = async (token) => {
    let url = `https://askell.is/api/temporarypaymentmethod/${token}/`;
    const response = await fetch(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Api-Key Jv81czzG.BUwlVZRI7xAUIHxXlga46gN3ehUOibGg'
        },
    });
    const data = await response.json();
    return data;

}

export const createTemporaryPaymentMethod = async (data = {}) => {
    let url = 'https://askell.is/api/temporarypaymentmethod/'
    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Api-Key Jv81czzG.BUwlVZRI7xAUIHxXlga46gN3ehUOibGg'
        },
        body: JSON.stringify(data)
    });
    return await response.json();
}